export const IconMultilojas = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M3.15 9.75h17.7c.634 0 1.15-.58 1.15-1.294 0-.256-.069-.506-.194-.717l-2.362-3.987C19.166 3.282 18.7 3 18.197 3H5.803c-.5 0-.969.281-1.247.752L2.194 7.736A1.43 1.43 0 0 0 2 8.453c0 .717.516 1.297 1.15 1.297M4 10.875v8.438C4 20.244 4.672 21 5.5 21h7c.828 0 1.5-.756 1.5-1.687v-8.438h-2V16.5H6v-5.625zm14 0v9c0 .622.447 1.125 1 1.125s1-.503 1-1.125v-9z" />
    </svg>
  );
};
